<script setup lang="ts">
import { computed } from "#imports";
// Import individual networks
import { x } from "./networks/x";
import { facebook } from "./networks/facebook";
import { instagram } from "./networks/instagram";
import { linkedin } from "./networks/linkedin";
import { whatsapp } from "./networks/whatsapp";
import { telegram } from "./networks/telegram";
import { reddit } from "./networks/reddit";
import { email } from "./networks/email";
import { pinterest } from "./networks/pinterest";
import { pocket } from "./networks/pocket";
import { bluesky } from "./networks/bluesky";
import { threads } from "./networks/threads";
import { line } from "./networks/line";
import { skype } from "./networks/skype";
import { viber } from "./networks/viber";
import MPImg from "../../widgets/MPImg.vue";

// Create a map of available networks
const availableNetworks = {
  x,
  facebook,
  instagram,
  linkedin,
  whatsapp,
  telegram,
  reddit,
  email,
  pinterest,
  pocket,
  bluesky,
  threads,
  line,
  skype,
  viber,
};

const props = defineProps<{
  network: keyof typeof availableNetworks;
  url: string;
  title?: string;
}>();

const getShareLink = computed(() => {
  const network = availableNetworks[props.network];
  if (!network) {
    return "";
  }

  let url = network.shareUrl.replace("[u]", props.url);

  if (network.args?.title && props.title) {
    url = url.replace("[t]", props.title);
  }

  return url;
});

const currentNetwork = computed(() => availableNetworks[props.network]);
</script>

<template>
  <a
    v-if="currentNetwork"
    :href="getShareLink"
    target="_blank"
    rel="noopener noreferrer"
    class="social-share-button"
    :title="`Share on ${currentNetwork.name}`"
  >
    <MPImg :src="currentNetwork.icon" />
  </a>
</template>

<style scoped lang="postcss">
.social-share-button {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;

  img {
    height: 2rem;
  }

  &:hover {
    opacity: 0.8;
  }
}
</style>
